import React from 'react';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Body, Caption } from '@spark/ui-components/components/Typography';
import Icon from '@spark/ui-components/components/Icon';
import Badge from '@spark/ui-components/components/Badge';
import { colorTextAdditional } from '@spark/ui-components/theme';
import styled from 'styled-components'; // Função para obter cor do tipo
// const getTipoColor = (tipo) => {
//   switch (tipo) {
//     case 'ACOMPANHAMENTO_NOVO':
//       return '#007bff'; // primary
//     case 'ACOMPANHAMENTO_MENSAGEM':
//       return '#17a2b8'; // info
//     case 'ACOMPANHAMENTO_ANEXO':
//       return '#ffc107'; // warning
//     case 'SISTEMA':
//       return '#6c757d'; // secondary
//     default:
//       return '#6c757d'; // secondary
//   }
// };
// // Função para obter ícone do tipo
// const getTipoIcon = (tipo) => {
//   switch (tipo) {
//     case 'ACOMPANHAMENTO_NOVO':
//       return 'package-variant';
//     case 'ACOMPANHAMENTO_MENSAGEM':
//       return 'comment-alert-outline';
//     case 'ACOMPANHAMENTO_ANEXO':
//       return 'paperclip';
//     case 'SISTEMA':
//       return 'information-outline';
//     default:
//       return 'notification';
//   }
// };
// Função para formatar data

const formatDate = dateString => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}; // Colunas para listagem de notificações


export const notificacaoColumns = (onMarcarLida, onVisualizar) => [{
  id: 'titulo',
  accessorKey: 'Titulo',
  header: 'Título',
  size: 260,
  cell: ({
    row
  }) => <div>
        <Body>
        {row.original.Mensagem?.length > 80 ? `${row.original.Mensagem.substring(0, 80)}...` : row.original.Mensagem}
        </Body>
      </div>
}, // {
//   id: 'tipo',
//   accessorKey: 'TipoNotificacao',
//   header: 'Tipo',
//   size: 160,
//   cell: ({ row }) => (
//     <TipoBadge tipo={row.original.TipoNotificacao}>
//       <Icon name={getTipoIcon(row.original.TipoNotificacao)} size={14} />
//       <Body>{row.original.TipoNotificacao}</Body>
//     </TipoBadge>
//   ),
// },
{
  id: 'numeroCarga',
  accessorKey: 'NumeroDaCarga',
  header: 'Nº Carga',
  size: 120,
  cell: ({
    row
  }) => <Body>{row.original.NumeroDaCarga || '-'}</Body>
}, {
  id: 'notas',
  accessorKey: 'NumerosNotasFiscais',
  header: 'Notas Fiscais',
  size: 220,
  cell: ({
    row
  }) => {
    const numeros = row.original.NumerosNotasFiscais;
    if (!numeros) return <Body>-</Body>;
    const list = String(numeros).split(',');
    return <Caption>
          {list.length <= 3 ? list.join(', ') : `${list.slice(0, 3).join(', ')} +${list.length - 3} mais`}
        </Caption>;
  }
}, {
  id: 'data',
  accessorKey: 'DataCriacao',
  header: 'Data',
  size: 160,
  cell: ({
    row
  }) => <Body>{formatDate(row.original.DataCriacao)}</Body>
}, {
  id: 'lida',
  accessorKey: 'Lida',
  header: 'Status',
  size: 120,
  cell: ({
    row
  }) => <Body>{row.original.Lida ? 'Lida' : 'Não lida'}</Body>
}, {
  id: 'acoes',
  header: 'Ações',
  size: 160,
  cell: ({
    row
  }) => <ActionButtons>
        <ButtonWithLoading variant="outline-primary" size="sm" onClick={(e) => { e.stopPropagation(); onVisualizar(row.original); }} title="Visualizar">
          <Icon name="eye" size={16} />
        </ButtonWithLoading>
        <ButtonWithLoading variant="outline-success" size="sm" onClick={(e) => { e.stopPropagation(); onMarcarLida(row.original); }} title="Marcar como lida" disabled={row.original.Lida}>
          <Icon name="check" size={16} />
        </ButtonWithLoading>
      </ActionButtons>
}]; // Estilos
// const TipoBadge = styled(Badge)`
//   background-color: ${props => getTipoColor(props.tipo)};
//   color: white;
//   font-weight: 500;
//   padding: 4px 8px;
//   border-radius: 4px;
//   display: flex;
//   align-items: center;
//   gap: 4px;
// `;

const StatusBadge = styled(Badge)`
  background-color: ${props => props.lida ? '#28a745' : '#ffc107'};
  color: white;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
`;
const ActionButtons = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
